/*
MIT LICENSE
Copyright (c) 2020-present Alibaba Cloud Design
Copied from 'antd/lib/switch/index.tsx'
Copyright (c) 2015-present Ant UED, https://xtech.antfin.com/

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE. */
import React from 'react';
import classNames from 'classnames';
import { SwitchChangeEventHandler, SwitchClickEventHandler } from 'antd/lib/switch';
import RcSwitch from 'rc-switch';
import { ConfigContext } from '../config-provider';
import SizeContext from '../config-provider/SizeContext';
import warning from 'antd/lib/_util/warning';
import { Loading } from '../loading';
const Switch = React.forwardRef((props, ref) => {
    if (process.env.NODE_ENV !== 'production')
        warning('checked' in props || !('value' in props), 'Switch', '`value` is not a valid prop, do you mean `checked`?');
    const { prefixCls: customizePrefixCls, loading, className = '', disabled } = props;
    const { size: customizeSize, type, ...otherProps } = props;
    const { getPrefixCls, direction } = React.useContext(ConfigContext);
    const size = React.useContext(SizeContext);
    const mergedSize = size || customizeSize;
    const prefixCls = getPrefixCls('switch', customizePrefixCls);
    let loadingSize = mergedSize === 'xs' || mergedSize === 'small' ? 'small' : 'default';
    const loadingIcon = (React.createElement("div", { className: `${prefixCls}-handle` }, loading && (React.createElement(Loading, { size: loadingSize, color: 'white', className: `${prefixCls}-loading-icon` }))));
    const classes = classNames({
        [`${prefixCls}-small`]: mergedSize === 'small',
        [`${prefixCls}-large`]: mergedSize === 'large',
        [`${prefixCls}-middle`]: mergedSize === 'middle',
        [`${prefixCls}-xs`]: mergedSize === 'xs',
        [`${prefixCls}-loading`]: loading,
        [`${prefixCls}-line`]: type === 'line',
        [`${prefixCls}-square`]: type === 'square',
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className);
    return (
    // @ts-ignore
    React.createElement(RcSwitch, { ...otherProps, prefixCls: prefixCls, className: classes, disabled: disabled || loading, ref: ref, loadingIcon: loadingIcon }));
});
Switch.__ANT_SWITCH = true;
Switch.displayName = 'Switch';
// const ConfiguredSwitch = withConfigProvider(Switch);
// export { ConfiguredSwitch as Switch };
// export default ConfiguredSwitch;
export { Switch };
export default Switch;
